import { memo } from 'react';
import { AppealStatus } from '../../types/appeals';
import { cn } from '../../utils/cn';

interface AppealStatusBadgeProps {
  status: AppealStatus;
  className?: string;
}

const STATUS_STYLES: Record<AppealStatus, string> = {
  pending: 'bg-yellow-500/15 text-yellow-300 border-yellow-500/25',
  awaiting_staff: 'bg-orange-500/15 text-orange-300 border-orange-500/25',
  staff_answered: 'bg-blue-500/15 text-blue-300 border-blue-500/25',
  in_jury: 'bg-purple-500/15 text-purple-300 border-purple-500/25',
  jury_decided: 'bg-indigo-500/15 text-indigo-300 border-indigo-500/25',
  approved: 'bg-green-500/15 text-green-300 border-green-500/25',
  denied: 'bg-red-500/15 text-red-300 border-red-500/25',
  escalated: 'bg-amber-500/15 text-amber-300 border-amber-500/25',
  cancelled: 'bg-gray-500/15 text-gray-300 border-gray-500/25',
};

const STATUS_LABELS: Record<AppealStatus, string> = {
  pending: 'Pending',
  awaiting_staff: 'Awaiting Staff',
  staff_answered: 'Staff Answered',
  in_jury: 'In Jury',
  jury_decided: 'Jury Decided',
  approved: 'Approved',
  denied: 'Denied',
  escalated: 'Escalated',
  cancelled: 'Cancelled',
};

export const AppealStatusBadge = memo(({ status, className }: AppealStatusBadgeProps) => {
  const style = STATUS_STYLES[status] || 'bg-gray-500/15 text-gray-300 border-gray-500/25';
  const label = STATUS_LABELS[status] || status.replace(/_/g, ' ');

  return (
    <span className={cn(
      'badge badge-dot capitalize',
      style,
      className,
    )}>
      {label}
    </span>
  );
});
